import {
  Button,
  Col,
  Input,
  List,
  message,
  notification,
  Row,
  Select,
  Statistic,
  Table,
  Tag,
} from "antd";
import printJS from "print-js";
import { useContext, useEffect, useRef, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { PACK_STATION, PackStation } from "../../../constants/option";
import { UserContext } from "../../../context/userContext";
import { ItemOrderPack, ItemPackSku } from "../../../Data/data_item"; // Import your mock data here
import { printBase64Pdf } from "../../../functions/printFile";
import { regexBarcode } from "../../../functions/regexBarcode";
import { GET, GETV2, POST } from "../../../services";
import {
  CHECKER_CONFIRM_PACK,
  CHECKER_FILE_ERR,
  CHECKER_GET_PACK_ORDER,
  CHECKER_GET_PACK_SKU,
  CHECKER_GET_STAT,
  CHECKER_OPEN_SO,
  CHECKER_RESYNC_WAY_BILL,
  GET_RECEIPT,
} from "../../../services/path";
import "../pack/style.css";
import ConfirmModal from "../pack/view/confirmModal";
import ConfirmNoFileModal from "../pack/view/confirmModelNofile";
import WarningNoFileModal from "../pack/view/์Nofile";
import WarningModal from "../pick/view/warningModal";

const PackFocus = () => {
  const [totalOrder, setTotalOrder] = useState("0");
  const [targetOrder, setTargetOrder] = useState("0");
  const [averageTime, setAverageTime] = useState("0");
  const [targetAverageTime, setTargetAverageTime] = useState("0");
  const [isTimeGood, setIsTimeGood] = useState(false);
  const [isAchieved, setIsAchieved] = useState(false);
  const [batchID, setBatchID] = useState("");
  const [sku, setSKU] = useState("");
  const [data, setData] = useState<ItemPackSku[]>([]);
  const [order, setOrder] = useState<ItemOrderPack[]>([]);
  const [platform, setPlatform] = useState<number | null>(null);
  const [packStationID, SetPackStationID] = useState<number | null>(null);
  const [orderNo, setOrderNo] = useState("");
  const [status, setStatus] = useState("");
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [filePath, setFilePath] = useState("");
  const [trackingNo, setTrackingNo] = useState("");
  const [batchNoScanned, setBatchNoScanned] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [isWarningNoFileModalVisible, setIsWarningNoFileModalVisible] = useState(false);
  const [isConfirmNoFileModalVisible, setIsConfirmNoFileModalVisible] = useState(false);
  const [confirmModalInfo, setConfirmModalInfo] = useState<{
    visible: boolean;
    batchID?: string;
    trackingNo?: string;
    orderNo?: string;
  }>({ visible: false });

  const [confirmMatch, setConfirmMatch] = useState(false);
  const [isloadingPrint, setIsloadingPrint] = useState(false);
  const [isloadingAll, setIsloadingAll] = useState(false);
  const [inputSequence, setInputSequence] = useState<any>([]);
  const [inputEnter, setInputEnter] = useState<any>([]);
  const { user } = useContext(UserContext);
  const skuInputRef = useRef<any>(null);
  const batchInputRef = useRef<any>(null);
  const packStationInputRef = useRef<any>(null);
  const [tabPressed, setTabPressed] = useState(false); // New state to track Tab key presses
  const { Option } = Select;
  const [filteredPackStation, setfilteredPackStation] = useState<PackStation[]>(PACK_STATION);
  const columns = [
    {
      title: "#",
      dataIndex: "run_number",
      key: "run_number",
      render: (_: any, _record: any, index: number) => (
        <div>
          <span style={{ marginLeft: 8 }}>{index + 1}</span>
        </div>
      ),
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (text: string) => (
        <div>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "item_name",
      key: "item_name",
      render: (text: string) => (
        <div>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
    {
      title: "ทั้งหมด",
      dataIndex: "show_qty",
      key: "show_qty",
      render: (text: number) => (
        <div>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
    {
      title: "ยิงแล้ว",
      dataIndex: "qty",
      key: "qty",
      render: (text: number) => (
        <div>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    handleGetStat();
    handleGetPackStation();
  }, []);
  const handleGetPackStation = async () => {
    const packStationID = localStorage.getItem("packStationID");
    if (packStationID) {
      SetPackStationID(Number(packStationID));
    }
  };

  const handleSearchPackStation = (value: string) => {
    const filteredData = PACK_STATION.filter((packStation) =>
      packStation.value.includes(value.toLowerCase()),
    );

    setfilteredPackStation(filteredData);
  };

  const handlePackStationIDChange = (packStationID: number | null) => {
    if (packStationID) {
      SetPackStationID(Number(packStationID));
      localStorage.setItem("packStationID", String(packStationID));
    }
  };

  const handleGetStat = async () => {
    try {
      const response = await GETV2(CHECKER_GET_STAT("packed"));
      setTotalOrder(response?.result?.total_order ?? 0);
      setAverageTime(response?.result?.average_time ?? 0);
      setTargetOrder(response?.result?.target_order ?? 0);
      setTargetAverageTime(response?.result?.target_average_time ?? 0);
      setIsAchieved(
        Number(response?.result?.total_order) >= Number(response?.result?.target_order),
      );
      setIsTimeGood(
        Number(response?.result?.average_time) <= Number(response?.result?.target_average_time),
      );
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.message ?? "Get stat fail!",
      });
    }
  };

  const fetchData = async () => {
    setIsloadingAll(true);
    try {
      const itemsResponse = await GET(CHECKER_GET_PACK_ORDER(batchID, "focus"));
      if (itemsResponse && itemsResponse.length > 0) {
        const orderAddIndex = itemsResponse.map((item: any, index: number) => ({
          ...item,
          index: index + 1,
        }));

        setOrder(orderAddIndex);
        return orderAddIndex;
      }
      return null;
    } catch (error) {
      console.error("Error fetching data:", error);
      return false;
    } finally {
      setIsloadingAll(false);
    }
  };

  const handleBatchEntered = async (batchID: string) => {
    if (!batchID.trim()) {
      notification.warning({
        message: "Batch Empty",
        description: "กรุณาใส่เลข Batch",
        duration: 3,
      });

      return;
    }

    setIsloadingAll(true);
    try {
      const batch_id = batchID;
      const brand = "focus";
      const itemsResponse = await GET(CHECKER_GET_PACK_ORDER(batch_id, brand));
      if (itemsResponse && itemsResponse.length > 0) {
        const orderAddIndex = itemsResponse.map((item: any, index: number) => ({
          ...item,
          index: index + 1,
        }));

        skuInputRef.current?.focus();
        const firstPlatformID = orderAddIndex[0].platform_id;
        setPlatform(firstPlatformID);
        setOrder(orderAddIndex);
        setBatchNoScanned(true);

        // Automatically fetch item details for the first order
        await handleItemClick(orderAddIndex[0], 0);
      }
    } catch (error) {
      console.error("Failed to fetch batch data:", error);
      setIsWarningModalVisible(true);
      setIsloadingAll(false);
    } finally {
      setIsloadingAll(false);
    }
  };

  // Handle SKU input change
  const handleSKUInputChange = (barcode: string) => {
    let formattedBarcode: string;
    if (barcode.startsWith("n=")) {
      formattedBarcode = regexBarcode(barcode);
    } else if (!isNaN(Number(barcode))) {
      const itemWithBarcode = data.find((item) => item.barcode === barcode);
      formattedBarcode = itemWithBarcode ? itemWithBarcode.sku : barcode;
    } else {
      formattedBarcode = barcode;
    }

    if (formattedBarcode.trim() !== "") {
      const matchingItem = data.find(
        (item) =>
          item.sku === formattedBarcode ||
          (formattedBarcode.includes("HYDRO") && item.barcode.includes(formattedBarcode)),
      );

      if (matchingItem && status === "picked") {
        const currentQuantity = matchingItem.qty || 0;
        const newQuantity = currentQuantity + 1;
        if (newQuantity > matchingItem.total_qty) {
          notification.warning({
            message: "เพิ่ม sku เกิน",
            description: "กรุณาใส่ตามจำนวน",
            duration: 6,
          });
        } else {
          setTotalQuantity((prevTotal) => prevTotal + 1);
          const updatedSkuQuantities = {
            ...data,
            [formattedBarcode]: newQuantity,
          };

          setData(updatedSkuQuantities);
          const updatedSkuData = data.map((item) =>
            item.sku === formattedBarcode ||
            (formattedBarcode.includes("HYDRO") && item.barcode.includes(formattedBarcode))
              ? {
                  ...item,
                  qty: newQuantity,
                  isFull: newQuantity === matchingItem.total_qty,
                  total_qty: matchingItem.total_qty,
                  barcode: matchingItem.barcode,
                }
              : item,
          );

          setData(updatedSkuData);
        }
      }
    } else {
      // หากข้อมูล SKU ว่าง, แสดงโมดัลคำเตือนBF231112195959-06410
      setIsWarningModalVisible(true);
    }
    // ล้างข้อมูลนำเข้า SKU หลังจากการประมวลผล
    setSKU("");
  };

  const onItemSelect = (item: ItemOrderPack, index: number) => {
    handleItemClick(item, index);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Tab" && isloadingAll === false) {
        event.preventDefault(); // Prevent the default tab behavior
        setTabPressed(true); // Set tabPressed to true when Tab is pressed
        setSelectedIndex((prevIndex) => {
          const nextIndex = prevIndex + 1;
          return nextIndex < order.length ? nextIndex : 0;
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [order.length, isloadingAll]);

  useEffect(() => {
    if (tabPressed && order.length > 0) {
      const effectiveIndex = selectedIndex < order.length ? selectedIndex : order.length - 1;
      handleItemClick(order[effectiveIndex], effectiveIndex);
      setInputEnter([]);
      setTabPressed(false);
    }
  }, [order, selectedIndex, tabPressed]);

  const handleCloseConfirmModal = async () => {
    setConfirmModalInfo({
      visible: false,
      batchID: undefined,
      trackingNo: undefined,
      orderNo: undefined,
    }); // Reset the modal state

    setData([]);
    const newOrderData = await fetchData();
    const orderList = Array.isArray(newOrderData) ? newOrderData : order;
    if (orderList.length > 0) {
      await handleItemClick(orderList[selectedIndex], selectedIndex);
    }
  };

  const handleCloseConfirmNoFileModal = async () => {
    setIsConfirmNoFileModalVisible(false);
    setData([]);
    const newOrderData = await fetchData();
    const orderList = Array.isArray(newOrderData) ? newOrderData : order;
    if (orderList.length > 0) {
      await handleItemClick(orderList[selectedIndex], selectedIndex);
    }
  };

  const resetStatesForNextOrder = () => {
    setConfirmModalInfo({
      visible: false,
      batchID: undefined,
      trackingNo: undefined,
      orderNo: undefined,
    }); // Reset modal state

    setConfirmMatch(false); // Reset match confirmation state
    message.success("Pack สำเร็จ: กำลังไป order ต่อไป....", 4.5);
  };

  const handleMatch = async () => {
    setConfirmMatch(true); // Indicate a match has been found

    // Step 1: Handle packed immediately
    const packSuccess = await handlePacked();
    if (!packSuccess) {
      setConfirmMatch(false);
      return;
    }

    // Step 2: Hook lazada api
    if (platform === 4) {
      handleHookLazada();
    }

    // Step 3: Trigger handleOpenSO without waiting for it to complete
    handleOpenSO();

    // Step 4: Fetch data and wait for it to complete
    setOrder([]);
    setData([]);
    setInputEnter([]);
    const newOrderData = await fetchData();

    // await handleItemClick(order[selectedIndex+1], selectedIndex+1)
    // After fetching data, calculate the effective index for the next item
    const orderList = Array.isArray(newOrderData) ? newOrderData : order;
    const newSelectedIndex = selectedIndex + 1;
    const effectiveIndex =
      newSelectedIndex < orderList.length ? newSelectedIndex : orderList.length - 1;

    // Ensure there's a next item to process
    if (orderList.length > 0 && effectiveIndex >= 0) {
      await handleItemClick(orderList[effectiveIndex], effectiveIndex);
    }

    resetStatesForNextOrder();
  };

  const handlePacked = async () => {
    const packerId = user.user_id;
    const payload = {
      packer_id: packerId,
      order_no: orderNo,
      brand: "focus",
      tracking_no: trackingNo,
      pack_station_id: packStationID,
    };

    try {
      await POST(CHECKER_CONFIRM_PACK, payload);
      notification.success({
        message: "Pack สำเร็จ",
        description: "กำลังไป order ต่อไป....",
        duration: 4.5,
      });
      return true;
    } catch (error) {
      notification.error({
        message: "File Error",
        description: "กรุณาติดต่อ Admin",
        duration: 4.5,
      });
      console.error("Error in submitting pack confirmation:", error);
      return false;
    } finally {
      await handleGetStat();
    }
  };

  const handleHookLazada = () => {
    const CHECKER_HOOK_LAZADA = `/webhook.dcapp.site/lazada/manual/publish/lazada.orders-shipment`;
    const payload = {
      data: {
        tracking_no: trackingNo,
      },
    };

    try {
      POST(CHECKER_HOOK_LAZADA, payload);
    } catch (error) {
      notification.error({
        message: "Fail hook lazada",
        description: "กรุณาติดต่อ Admin",
        duration: 4, // Duration the notification stays open
      });

      console.error("Error in hook lazada api:", error);
    }
  };

  const handleOpenSO = async () => {
    const packerId = user.user_id;
    const payload = {
      packer_id: packerId,
      order_no: orderNo,
      brand: "focus",
    };

    try {
      const response = await POST(CHECKER_OPEN_SO, payload);
      if (response.status === 500) {
        notification.warning({
          message: "Server Error",
          description: "เปิด So ไม่สำเร็จ, กรุณาติดต่อ Admin",
          duration: 4.5,
        });
      }
    } catch (error) {
      console.error("Error in submitting pack confirmation:", error);
    }
  };

  // พิมพ์ใบเสร็จก่อนใบปะหน้า (ยกมาจาก checker_frontend bewell/pack)
  // error ทุกกรณีถูกกลืนไว้ เพื่อให้ flow ใบปะหน้าทำงานต่อได้เสมอ
  const printReceipt = async (order_no: string, tracking_no: string) => {
    if (!order_no || !tracking_no) return;
    try {
      const response = await GET(GET_RECEIPT(order_no, tracking_no));
      if (response?.success === true) {
        if (response?.result) await printBase64Pdf(response.result);
      } else {
        console.error("Failed to fetch receipt data:", response);
      }
    } catch (error) {
      console.error("Error fetching receipt:", error);
    }
  };

  const afterPrint = async () => {
    setConfirmModalInfo({
      visible: true,
      batchID: batchID,
      trackingNo: trackingNo,
      orderNo: orderNo,
    });
  };

  const printErr = async () => {
    setConfirmModalInfo({
      visible: true,
      batchID: batchID,
      trackingNo: trackingNo,
      orderNo: orderNo,
    });
  };

  const handleFileErr = async () => {
    const payload = {
      file_path: filePath,
      order_no: orderNo,
      tracking_no: trackingNo,
    };

    try {
      await POST(CHECKER_FILE_ERR, payload);
      message.warning("File Error: กรุณาติดต่อ Admin!!", 4.5);
    } catch {
      message.error("File Broken: กรุณาติดต่อ Admin!!", 4.5);
    }
  };

  const handlePrint = async (overrideUrl?: any) => {
    const url = typeof overrideUrl === "string" ? overrideUrl : filePath;
    try {
      setIsloadingPrint(true);
      await new Promise<void>((resolve, reject) => {
        let errorOccurred = false;
        printJS({
          printable: url,
          onError: async (error) => {
            errorOccurred = true;
            notification.info({
              message: "Reloading",
              description: "Fetching latest data...",
              duration: 2,
            });

            try {
              const itemsResponse = await GET(CHECKER_GET_PACK_ORDER(batchID, "focus"));
              if (itemsResponse && itemsResponse.length > 0) {
                const orderAddIndex = itemsResponse.map((item: any, index: number) => ({
                  ...item,
                  index: index + 1,
                }));
                const updatedItem = orderAddIndex.find((o: any) => o.order_no === orderNo);

                if (updatedItem && updatedItem.file_path) {
                  setFilePath(updatedItem.file_path);
                  setOrder(orderAddIndex);

                  notification.success({
                    message: "Data Reloaded",
                    description: "Retrying print...",
                    duration: 2,
                  });

                  await new Promise<void>((retryResolve, retryReject) => {
                    let retryErrorOccurred = false;
                    printJS({
                      printable: updatedItem.file_path,
                      onError: (retryError) => {
                        retryErrorOccurred = true;
                        notification.error({
                          message: "Print Error",
                          description: "ไม่มีใบปะหน้า",
                          duration: 2,
                        });
                        printErr();
                        retryReject(retryError);
                      },
                      onPrintDialogClose: () => {
                        if (!retryErrorOccurred) {
                          afterPrint();
                          notification.success({
                            message: "Print Success",
                            description: "กำลัง Pack....",
                            duration: 2,
                          });
                        }
                        retryResolve();
                      },
                    });
                  });
                } else {
                  notification.error({
                    message: "Print Error",
                    description: "ไม่มีใบปะหน้า",
                    duration: 2,
                  });
                  printErr();
                  reject(error);
                }
              }
            } catch (reloadError) {
              console.error("Error reloading data:", reloadError);
              notification.error({
                message: "Print Error",
                description: "ไม่มีใบปะหน้า",
                duration: 2,
              });
              printErr();
              reject(reloadError);
            }
          },
          onPrintDialogClose: () => {
            if (!errorOccurred) {
              afterPrint();
              notification.success({
                message: "Print Success",
                description: "กำลัง Pack....",
                duration: 2,
              });
            }
            resolve();
          },
        });
      });
    } catch (error) {
      console.error("Error in printing:", error);
      handleFileErr();
      notification.error({
        message: "Print Error",
        description: "An error occurred during printing.",
        duration: 6,
      });
    } finally {
      setIsloadingPrint(false);
    }
  };

  const handleRePrint = async () => {
    const url = filePath;
    try {
      setIsloadingPrint(true);
      if (!filePath) {
        handleFileErr();
        notification.error({
          message: "Print Error",
          description: "ไม่มีใบปะหน้า",
          duration: 6,
        });

        return;
      }

      await new Promise<void>((resolve, reject) => {
        let errorOccurred = false;
        printJS({
          printable: url,
          onError: async (error) => {
            errorOccurred = true;
            notification.info({
              message: "Reloading",
              description: "Fetching latest data...",
              duration: 2,
            });

            try {
              const itemsResponse = await GET(CHECKER_GET_PACK_ORDER(batchID, "focus"));
              if (itemsResponse && itemsResponse.length > 0) {
                const orderAddIndex = itemsResponse.map((item: any, index: number) => ({
                  ...item,
                  index: index + 1,
                }));
                const updatedItem = orderAddIndex.find((o: any) => o.order_no === orderNo);

                if (updatedItem && updatedItem.file_path) {
                  setFilePath(updatedItem.file_path);
                  setOrder(orderAddIndex);

                  notification.success({
                    message: "Data Reloaded",
                    description: "Retrying print...",
                    duration: 2,
                  });

                  await new Promise<void>((retryResolve, retryReject) => {
                    let retryErrorOccurred = false;
                    printJS({
                      printable: updatedItem.file_path,
                      onError: (retryError) => {
                        retryErrorOccurred = true;
                        notification.error({
                          message: "Print Error",
                          description: "ไม่มีใบปะหน้า",
                          duration: 2,
                        });
                        printErr();
                        retryReject(retryError);
                      },
                      onPrintDialogClose: () => {
                        if (!retryErrorOccurred) {
                          afterPrint();
                          notification.success({
                            message: "Print Success",
                            description: "กำลัง Pack....",
                            duration: 2,
                          });
                        }
                        retryResolve();
                      },
                    });
                  });
                } else {
                  notification.error({
                    message: "Print Error",
                    description: "ไม่มีใบปะหน้า",
                    duration: 2,
                  });
                  printErr();
                  reject(error);
                }
              }
            } catch (reloadError) {
              console.error("Error reloading data:", reloadError);
              notification.error({
                message: "Print Error",
                description: "ไม่มีใบปะหน้า",
                duration: 2,
              });
              printErr();
              reject(reloadError);
            }
          },
          onPrintDialogClose: () => {
            if (!errorOccurred) {
              afterPrint();
              notification.success({
                message: "Print Success",
                description: "กำลัง Pack....",
                duration: 2,
              });
            }

            resolve();
          },
        });
      });
    } catch (error) {
      console.error("Error in printing:", error);
      setIsloadingPrint(false);
      notification.error({
        message: "Print Error",
        description: "An error occurred during printing.",
        duration: 6,
      });
    } finally {
      setIsloadingPrint(false);
    }
  };

  const handleItemClick = async (item: ItemOrderPack, index: number) => {
    try {
      setSelectedIndex(index); // Add this line to update selectedIndex on item click
      setIsloadingAll(true);
      setOrderNo(item.order_no);
      setStatus(item.operation_status);
      setFilePath(item.file_path);
      setTrackingNo(item.tracking_no);
      setData([]);
      const response = await GET(CHECKER_GET_PACK_SKU(item.order_no, item.tracking_no));
      if (response && response.length > 0) {
        setData(response);
      }
    } catch (error) {
      setIsloadingAll(false);
      console.error("Error fetching SKUs:", error);
    } finally {
      setIsloadingAll(false);
    }
  };

  //Color ใน Order Item
  const specificStatuses = [
    "picked",
    "confirm",
    "ready",
    "unoperate",
    "cancel",
    "return",
    "waiting",
  ];

  const WaitingOrder = ["waiting"];

  //Permission button
  const btnbyStatus = ["picked", "packed"];

  const isShowBtnPrint =
    btnbyStatus.includes(status) &&
    filePath !== "" &&
    ((data.every((item) => item.isFull) && status !== "picked") || status !== "picked") &&
    data.length > 0;
  const isShowBtnPrint2 =
    data.every((item) => item.isFull) && status === "picked" && data.length > 0;

  const isShowBtnNextBatch =
    order.every((item) => item.operation_status !== "picked") &&
    data.length > 0 &&
    order.length > 0;

  useEffect(() => {
    if (!packStationID) {
      packStationInputRef.current?.focus();
    }

    if (packStationID && !batchID) {
      batchInputRef.current?.focus();
    }

    if (packStationID && batchID && status === "picked" && !isShowBtnPrint) {
      skuInputRef.current?.focus();
    }
  }, [batchID, status, isShowBtnPrint, order, packStationID]);

  const resetAllStates = () => {
    setBatchID("");
    setSKU("");
    setData([]);
    setOrder([]);
    setOrderNo("");
    setStatus("");
    setTrackingNo("");
    setTotalQuantity(0);
    setBatchNoScanned(false);
    setInputEnter([]);
    setInputSequence([]);
    setIsWarningModalVisible(false);
    setIsWarningNoFileModalVisible(false);
    setConfirmModalInfo({
      visible: false,
      batchID: undefined,
      trackingNo: undefined,
      orderNo: undefined,
    });

    setConfirmMatch(false);
    setIsConfirmNoFileModalVisible(false);
  };

  const handleClearState = (event: any) => {
    setInputSequence([event.key]);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleClearState);
    return () => {
      window.removeEventListener("keydown", handleClearState);
    };
  }, [inputSequence]);

  useEffect(() => {
    const sequenceAsString = inputSequence.join(" ");
    if (sequenceAsString.includes("ArrowRight") && isShowBtnNextBatch) {
      resetAllStates();
    }
  }, [inputSequence]);

  const handleEnterPrint = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      setInputEnter(event.key);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEnterPrint);
    return () => {
      window.removeEventListener("keydown", handleEnterPrint);
    };
  }, [inputEnter]);

  useEffect(() => {
    const printReceiptThenLabel = async () => {
      await printReceipt(orderNo, trackingNo);
      await handlePrint();
    };

    if (inputEnter === "Enter") {
      if (
        isShowBtnPrint &&
        status !== "picked" &&
        confirmModalInfo.visible === false &&
        selectedIndex !== 0
      ) {
        handleRePrint();
      } else if (
        isShowBtnPrint2 &&
        status === "picked" &&
        confirmModalInfo.visible === false &&
        confirmMatch === false
      ) {
        printReceiptThenLabel();
      }

      if (inputEnter.length !== 0) {
        setInputEnter([]); // Preventing this from causing an infinite loop
      }
    }
  }, [inputEnter]);

  const getOperationStatusBySKU = (sku: string) => {
    const orderItem = order.find((o) => o.order_no === orderNo);
    return orderItem ? orderItem.operation_status : null;
  };

  const getColorByStatus = (status: string, currentNo: string) => {
    switch (status) {
      case "picked":
        return "#ff6666"; // Dark red color
      case "packed":
        return "#66cc66"; // Dark green color
      case "complete":
        return "#66cc66"; // Dark green color for 'complete' status
      default:
        return "grey"; // Default color remains the same
    }
  };

  const getColorByStatustag = (status: string) => {
    switch (status) {
      case "unoperate":
        return "#9E9E9E"; // Grey - Indicating inactive or not operated
      case "ready":
        return "#64B5F6"; // Light Blue - Ready state
      case "picked":
        return "#4DB6AC"; // Teal - Picked items
      case "packed":
        return "#81C784"; // Green - Successfully packed
      case "checked out":
        return "#2E7D32"; // Green - Checked out
      case "shipping":
        return "#FFD54F"; // Amber - In transit/shipping
      case "complete":
        return "#AED581"; // Light Green - Completed
      case "waiting":
        return "#FFB74D"; // Orange - Waiting for action
      case "cancel":
        return "#E57373"; // Red - Cancelled
      case "return":
        return "#BA68C8"; // Purple - Returned items
      case "confirm":
        return "#7986CB"; // Indigo - Confirmed status
      default:
        return "#E0E0E0"; // Default light grey for undefined statuses
    }
  };
  const handleResyncWaybill = async (e: React.MouseEvent, currentItem: ItemOrderPack) => {
    e.stopPropagation();
    setIsloadingAll(true);
    try {
      notification.info({
        message: "Reloading",
        description: "กำลัง Generate ใบปะหน้า...",
        duration: 3,
      });

      let resolvedFilePath: string | null = null;
      const firstResponse = await GET(CHECKER_GET_PACK_ORDER(batchID, "focus"));
      if (firstResponse && firstResponse.length > 0) {
        const orderAddIndex = firstResponse.map((item: any, index: number) => ({
          ...item,
          index: index + 1,
        }));
        setOrder(orderAddIndex);
        const updatedItem = orderAddIndex.find((o: any) => o.order_no === currentItem.order_no);
        if (updatedItem?.file_path) {
          try {
            const checkRes = await fetch(updatedItem.file_path, { method: "HEAD" });
            const contentType = checkRes.headers.get("content-type") ?? "";
            if (checkRes.status === 200 && contentType.includes("pdf")) {
              resolvedFilePath = updatedItem.file_path;
            } else if (checkRes.status === 404) {
              console.log("File Broken");
            }
          } catch {
            console.log("File Broken");
          }
        }
      }
      if (!resolvedFilePath) {
        await POST(CHECKER_RESYNC_WAY_BILL(currentItem.order_no), {});

        const retryResponse = await GET(CHECKER_GET_PACK_ORDER(batchID, "focus"));
        if (retryResponse && retryResponse.length > 0) {
          const orderAddIndex = retryResponse.map((item: any, index: number) => ({
            ...item,
            index: index + 1,
          }));
          setOrder(orderAddIndex);
          const updatedItem = orderAddIndex.find((o: any) => o.order_no === currentItem.order_no);
          if (updatedItem?.file_path) {
            resolvedFilePath = updatedItem.file_path;
          }
        }
      }

      if (resolvedFilePath) {
        if (currentItem.order_no === orderNo) {
          setFilePath(resolvedFilePath);
          if (data.every((item) => item.isFull)) {
            await printReceipt(currentItem.order_no, currentItem.tracking_no);
            handlePrint(resolvedFilePath);
            notification.success({
              message: "พบใบปะหน้าแล้ว",
              description: "กำลังปริ้นใบปะหน้า...",
              duration: 3,
            });
          } else {
            notification.warning({
              message: "พบใบปะหน้าแล้ว",
              description: `กรุณาสแกนสินค้าให้ครบถ้วน`,
              duration: 3,
            });
          }
        } else {
          notification.success({
            message: "ดึงใบปะหน้าสำเร็จ",
            description: `อัปเดตใบปะหน้าของ Order #${currentItem.order_no} เรียบร้อยแล้ว`,
            duration: 3,
          });
        }
      } else {
        notification.warning({
          message: "ไม่พบใบปะหน้าจากระบบ",
          description: `ไม่สามารถ Generate ใบปะหน้าได้ Order #${currentItem.order_no}`,
          duration: 4,
        });
      }
    } catch (error) {
      console.error("Error reloading order:", error);
      notification.error({
        message: "Error",
        description: "ไม่สามารถ Generate ใบปะหน้าได้ กรุณาติดต่อ Admin",
        duration: 4,
      });
    } finally {
      setIsloadingAll(false);
    }
  };
  return (
    <LoginedLayout>
      <ContentBox>
        <div
          style={{
            marginBottom: "16px",
            borderBottom: "1px solid #e8e8e8",
            paddingBottom: "8px",
          }}
        >
          <h2 style={{ marginBottom: "8px" }}># Pack Focus </h2>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Statistic
            title={<div style={{ textAlign: "center", fontSize: 13 }}>Order Target</div>}
            value={totalOrder}
            suffix={`/ ${targetOrder} Order`}
            valueStyle={{
              fontWeight: 700,
              fontSize: 18,
              textAlign: "center",
              lineHeight: "1.2",
              color: isAchieved ? "#52c41a" : "#ff4d4f",
            }}
            style={{
              width: "100%",
              maxWidth: 240,
              margin: "6px",
              padding: "8px",
              border: `1.5px solid ${isAchieved ? "#52c41a" : "#ff4d4f"}`,
              borderRadius: 8,
              boxShadow: `0px 4px 10px ${isAchieved ? "#52c41a" : "#ff4d4f"}`,
            }}
          />
          <Statistic
            title={<div style={{ textAlign: "center", fontSize: 13 }}>Avg. Time</div>}
            value={averageTime}
            suffix={` / ${targetAverageTime} Sec.`}
            valueStyle={{
              fontWeight: 700,
              fontSize: 18,
              textAlign: "center",
              lineHeight: "1.2",
              color: isTimeGood ? "#52c41a" : "#ff4d4f",
            }}
            style={{
              width: "100%",
              maxWidth: 240,
              margin: "6px",
              padding: "8px",
              border: `1.5px solid ${isTimeGood ? "#52c41a" : "#ff4d4f"}`,
              borderRadius: 8,
              boxShadow: `0px 4px 10px ${isTimeGood ? "#52c41a" : "#ff4d4f"}`,
            }}
          />
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <List
              itemLayout="horizontal"
              dataSource={order}
              loading={isloadingAll}
              renderItem={(item, index) => (
                <List.Item
                  onClick={() => onItemSelect(item, index)}
                  className="clickable-list-item"
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: getColorByStatus(item.operation_status, item.order_no), // Set background color based on status
                    border: orderNo === item.order_no ? "4px solid blue" : "none", // Highlight if current
                    boxSizing: "border-box", // Ensure border doesn't affect item size
                  }}
                >
                  <List.Item.Meta
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          width: "100%",
                          gap: "15px",
                        }}
                      >
                        <span>Order #{item.order_no}</span>
                        {typeof item.operation_status === "string" ? (
                          <Tag
                            style={{
                              backgroundColor: getColorByStatustag(item.operation_status),
                              color: "black",
                            }}
                          >
                            {item.operation_status}
                          </Tag>
                        ) : (
                          item.operation_status
                        )}
                        {!item.file_path ? (
                          <Tag color="red"> No File </Tag> // Display this tag if file_path is null
                        ) : null}
                        {item.operation_status === "picked" ? (
                          <Button
                            size="small"
                            type="primary"
                            style={{
                              marginLeft: "auto",
                              marginRight: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={(e) => handleResyncWaybill(e, item)}
                          >
                            Reload
                          </Button>
                        ) : null}
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={16} xl={18}>
            <ContentBox>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Pack Station ID:</label>
                  <Select<number>
                    showSearch
                    ref={packStationInputRef}
                    placeholder="กรุณาเลือก Pack station ID"
                    filterOption={false} // Disable default filtering
                    onSearch={handleSearchPackStation}
                    notFoundContent={null}
                    style={{ flex: "1", marginRight: "10px" }}
                    value={packStationID}
                    onSelect={handlePackStationIDChange}
                    disabled={batchNoScanned || isShowBtnPrint}
                  >
                    {filteredPackStation.map((p) => (
                      <Option key={p.id} value={p.value}>
                        {p.value}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Search Batch No.:</label>
                  <Input
                    value={batchID}
                    ref={batchInputRef}
                    onChange={(e) => setBatchID(e.target.value)}
                    placeholder="กรุณาใส่เลข Batch"
                    onPressEnter={(e: any) => handleBatchEntered(e.target.value)}
                    style={{ flex: "1", marginRight: "10px" }}
                    disabled={batchNoScanned || isShowBtnPrint || !packStationID}
                    width={"100vw"}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Sku:</label>
                  <Input
                    value={sku}
                    onChange={(e) => setSKU(e.target.value)}
                    placeholder="กรุณาใส่เลข SKU"
                    onPressEnter={(e: any) => handleSKUInputChange(e.target.value)}
                    style={{ flex: "1" }}
                    disabled={
                      !batchID || status !== "picked" || isShowBtnPrint || isShowBtnNextBatch
                    }
                    ref={skuInputRef}
                  />
                  <div style={{ marginRight: "10px", marginLeft: "10px" }}>
                    Total: {totalQuantity}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Batch No:</label>
                  <div style={{ flex: "1" }}>{batchID}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Order No:</label>
                  <div style={{ flex: "1" }}>{orderNo}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Status:</label>
                  <div style={{ flex: "1" }}>{status}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <label style={{ width: "150px", marginRight: "12px" }}>Tracking No:</label>
                  <div style={{ flex: "1" }}>{trackingNo}</div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "16px",
                }}
              >
                {isShowBtnPrint && (
                  <Button
                    type="primary"
                    size="large"
                    loading={isloadingPrint}
                    style={{
                      marginTop: "20px",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "100%",
                      maxWidth: "150px",
                    }}
                    onClick={handlePrint}
                  >
                    Print
                  </Button>
                )}
                {isShowBtnNextBatch && (
                  <Button
                    type="primary"
                    size="large"
                    loading={isloadingPrint}
                    style={{
                      marginTop: "20px",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "100%",
                      maxWidth: "150px",
                      backgroundColor: "red", // Set background color to red
                      borderColor: "red", // Set border color to red
                      color: "white", // Optional: change text color to white for better visibility
                    }}
                    onClick={resetAllStates}
                  >
                    Next Batch
                  </Button>
                )}
              </div>
            </ContentBox>
            <Table
              columns={columns}
              dataSource={data}
              rowKey="sku"
              loading={isloadingAll}
              rowClassName={(record) => {
                const operationStatus = getOperationStatusBySKU(record.sku);
                if (
                  record.isFull ||
                  (operationStatus && !specificStatuses.includes(operationStatus))
                ) {
                  return "green-row";
                } else if (operationStatus && WaitingOrder.includes(operationStatus)) {
                  return "blue-row";
                } else if (record.qty < record.total_qty) {
                  return "yellow-row";
                } else {
                  return "red-row";
                }
              }}
            />
          </Col>
        </Row>
        {isWarningModalVisible && (
          <WarningModal
            onClose={() => setIsWarningModalVisible(false)}
            visible={isWarningModalVisible}
          />
        )}
        {isWarningNoFileModalVisible && (
          <WarningNoFileModal
            onClose={() => {
              setIsWarningNoFileModalVisible(false);
              setIsConfirmNoFileModalVisible(true);
            }}
            visible={isWarningNoFileModalVisible}
            message="This order doesn't have a packing slip." // Message to display in the modal
          />
        )}
        {isConfirmNoFileModalVisible && (
          <ConfirmNoFileModal
            onClose={handleCloseConfirmNoFileModal}
            onMatch={handleMatch}
            visible={isConfirmNoFileModalVisible}
          />
        )}
        {confirmModalInfo && confirmModalInfo.visible ? (
          <ConfirmModal
            onClose={handleCloseConfirmModal}
            onMatch={handleMatch}
            visible={confirmModalInfo.visible}
            batchID={confirmModalInfo.batchID}
            trackingNo={confirmModalInfo.trackingNo}
            orderNo={confirmModalInfo.orderNo}
          />
        ) : null}
      </ContentBox>
    </LoginedLayout>
  );
};

export default PackFocus;
